<template>
  <div class="ds-control dsf_teas_meal_application mobile">
    <van-search v-model="searchValue" show-action shape="round" placeholder="搜索" @search="search()" v-if="showSearch">
      <template #action>
        <div @click="onSearch" class="application_filter">
          <i class="iconfont icon-icon_filter"></i>
        </div>
      </template>
    </van-search>
    <div class="aplication_list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length" style="min-height: 80vh;">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" :error.sync="error">
          <DsfMobileTeasCell :title="item.name" class="list_item" v-for="(item,index) in list" :key="index" @click.native="listClick(item,index)">
            <div slot="titleRight" class="item_right" :class="[item.attend_status &&item.attend_status.value?'item_color_'+item.attend_status.value:'']" v-if="item.attend_status">{{item.attend_status.text}}</div>
            <DsfMobileTeasCellItem :label="item.type.text || '无'" class="list_mark"></DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem :label="item.addr || '无'" icon="icon-location-hollow"></DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem :label="item.duration | dateFormat" icon="icon-icon-date"></DsfMobileTeasCellItem>
          </DsfMobileTeasCell>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="暂无数据" />
    </div>
    <div class="application_zwf" v-if="showBtn"></div>
    <div class="aplication_btn" v-if="showBtn && !isDesign">
      <slot name="btn">
        <div @click="addBtn">新增</div>
      </slot>
    </div>
    <van-popup v-model="showPicker" round position="bottom" get-container="#app">
      <div class="appilcation_picker">
        <div class="picker_tit">
          <div></div>
          <span>筛选条件</span>
          <i class="iconfont icon-guanbi2" @click="showPicker=false"></i>
        </div>
        <div class="picker_type">会议时间</div>
        <div class="picker_date">
          <div @click="showDate=true">{{startDate ||'开始时间'}}</div>
          <span>-</span>
          <div @click="showDate=true">{{endDate||'结束时间'}}</div>
        </div>
        <div class="picker_type">会议类别</div>
        <div class="picker_select">
          <div class="select_item" @click="chooseChange(item,index)" v-for="(item,index) of typeArr" :key="index" :class="[item.check?'chooseType':'']">{{item.text}}</div>
        </div>
        <div class="picker_btn">
          <div class="btn_cz" @click="pickerCz">重置</div>
          <div class="btn_qd" @click="pickerSure">确定</div>
        </div>
      </div>
    </van-popup>
    <van-calendar v-model="showDate" type="range" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" get-container="#app" class="list_box_calendar"/>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasManagementMeetingsList",
  ctrlCaption: "会议管理列表",
  mixins: [$mixins.control],
  data() {
    return {
      searchValue: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      showPicker: false,
      showDate: false,
      //   筛选条件开始时间
      startDate: '',
      //   结束时间
      endDate: '',
      //   类别数据
      typeArr: [],
      pageNum: 0,
      pageSize: 10,
      listCount: 0,
      minDate: null,
      maxDate: null,
    }
  },
  filters: {
    dateFormat(val) {
      if (val.sdate && val.edate) {
        let start = val.sdate.substring(0, 16);
        let end = val.edate.substring(0, 16);
        return start + ' 至 ' + end
      } else {
        return '无'
      }
    }
  },
  props: {
    //   按钮
    showBtn: {
      type: Boolean,
      default: false
    },
    // 搜索框
    showSearch: {
      type: Boolean,
      default: true
    },
    url: {
      type: String,
      default: 'teas/logistic/mobile/meeting/listMeeting'
    },
    rmId: {
      type: String,
      default: '56892d91545b49859e08c8a8bf590907'
    }
  },
  created() {
    if (this.isDesign) {
      this.list.push({
        "duration": {
          "sdate": "2022-06-17 00:00:00",
          "edate": "2022-06-18 00:00:00"
        },
        "name": "asdfasdf",
        "_id": "822a4f50d46642359a9505d5c81bdcd2",
        "addr": null,
        "type": {
          "text": "校委会",
          "value": "2"
        }
      })
    } else {
      let now = new Date();
      let year = now.getFullYear();
      let mon = now.getMonth() + 1;
      let day = now.getDate();
      this.minDate = new Date(year - 10, mon, day);
      this.maxDate = new Date(year + 10, mon, day);
      this.getType()
      this.getList()
    }

  },
  activated() {
    this.list = [];
    this.pageNum = 0;
    this.refreshing = false;
    this.finished = false;
    this.getList();
  },
  methods: {
    search() {
      this.pageNum = 0;
      this.list = [];
      this.getList()
    },
    addBtn() {
      this.$emit('add')
    },
    pickerCz() {
      this.startDate = "";
      this.endDate = "";
      this.typeArr.forEach(element => {
        element.check = false;
      })

    },
    pickerSure() {
      this.showPicker = false;
      this.pageNum = 0;
      this.refreshing = false;
      this.finished = false;
      this.list = [];
      this.getList()
    },
    listClick(item, index) {
      this.$emit('click', { item, index })
    },
    // 获取列表数据
    getList(isRefresh = false) {
      if (this.isDesign) {
        this.finished = true;
        return
      }
      this.pageNum++;
      let meeting_types = []
      this.typeArr.forEach(element => {
        if (element.check) {
          meeting_types.push(element.value)
        }
      })
      let data = {
        startTime: this.startDate ? this.startDate + '00:00:00' : '',
        endTime: this.endDate ? this.endDate + '23:59:59' : '',
        meeting_types: meeting_types.join(','),
        name: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.queryString.audit) {
        data.audit = this.queryString.audit
      }
      this.$http.get(this.url, data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          if (isRefresh) {
            this.list = res.data.list
          } else {
            this.list.push(...res.data.list);
          }
          this.listCount = res.data.count;
          if (this.listCount == this.list.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          dsf.layer.message(res.message, false);
          this.error = true;
          this.finished = true;
        }
      })
        .error((err) => {
          this.error = true;
          this.finished = true;
          dsf.layer.message(err.message || "出错了，请重试", false);
        }).always(() => {
          this.loading = false;
          this.refreshing = false
        })
    },
    onRefresh() {
      this.pageNum = 0;
      this.getList(true);
    },
    onSearch() {
      this.showPicker = true
    },
    onConfirm(data) {
      this.startDate = this.getTime(data[0])
      this.endDate = this.getTime(data[1])
      this.showDate = false;
    },
    chooseChange(val, index) {
      this.typeArr[index].check = !this.typeArr[index].check;
    },
    getTime(val) {
      let date = new Date(val);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = date.getDate() + ' ';
      return Y + M + D
    },
    getType() {
      this.$http.get(`dict/getList/${this.rmId}`, {}, $$webRoot.dsfa).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          let data = res.data;
          data.forEach(element => {
            this.typeArr.push({
              ...element,
              check: false
            })
          })
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    }
  },
})
</script>

<style>
</style>